<!-- Model Header -->
<div class="d-flex model-container justify-content-between bg-color overflow-hidden">
    <h3 class="text-color f-w-600 p-l-10 m-y-auto">Referee Detail</h3>
    <button mat-icon-button class="text-color" (click)="this.dialogRef.close()" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<!-- Model Body -->
<div mat-dialog-content class="model-body">


    <mat-label class="f-s-14 f-w-600 m-b-2 d-block">Referee Name</mat-label>
    <mat-label class="f-s-12 m-b-12 d-block text-left">John</mat-label>


    <mat-label class="f-s-14 f-w-600 m-b-2 d-block">Email</mat-label>
    <mat-label class="f-s-12 m-b-12 d-block text-left">{{'dk@yopmail.com'}}</mat-label>

    <mat-label class="f-s-14 f-w-600 m-b-2 d-block">PhoneNumber</mat-label>
    <mat-label class="f-s-12 m-b-12 d-block text-left">{{'123456789'}}</mat-label>

    <mat-label class="f-s-14 f-w-600 m-b-2 d-block">Status</mat-label>
    <mat-label class="f-s-12 m-b-12 d-block text-left">{{'Approve'}}</mat-label>

    <mat-label class="f-s-14 f-w-600 m-b-2 d-block">Government ID</mat-label>
    <mat-label class="f-s-12 m-b-12 d-block text-left">{{'12345'}}</mat-label>

    <mat-label class="f-s-14 f-w-600 m-b-2 d-block">Passport</mat-label>
    <mat-label class="f-s-12 m-b-12 d-block text-left">{{'12345'}}</mat-label>


    <mat-label class="f-s-14 f-w-600 m-b-2 d-block">License Number</mat-label>
    <mat-label class="f-s-12 m-b-12 d-block text-left">{{'12345'}}</mat-label>

    <div>
        <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Bank Detail</mat-label>
        <div class="m-l-12">
            <mat-label class="f-s-14 f-w-600 m-b-2 d-block">Bank Name</mat-label>
            <mat-label class="f-s-12 m-b-12 d-block text-left">{{'State bank'}}</mat-label>

            <mat-label class="f-s-14 f-w-600 m-b-2 d-block">Bank Number</mat-label>
            <mat-label class="f-s-12 m-b-12 d-block text-left">{{'12345'}}</mat-label>
        </div>
    </div>


    <!-- <p>This is a responsive modal dialog using Angular Material.</p> -->
</div>

<!-- Model Footer -->
<div mat-dialog-actions>
    <button class="bg-color text-color" mat-button>Approve</button>
    <button class="bg-color text-color" mat-button>Reject</button>

    <button class="bg-color text-color" mat-button (click)="this.dialogRef.close()">Close</button>
</div>